import React from "react";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import SlotDetailsFields from "../../../constants/SlotDetails/SlotDetailsFields";
import AuditDetailsFields from "../../../constants/SlotDetails/AuditDetailsFields";
import { exportToCSV, getPath, isValNull } from "../../../utils";
import BlankState from "../../Common/BlankState";
import Table from "../../Common/Table";
import moment from "moment";
import Download from "sushiweb/Icons/all/Download";

const scrollableFields = ["booked_by_drivers", "cancelled_by_drivers"];

const SlotDetailsList = ({ data }) => {
  const getFieldValue = (obj, key) => {
    if (key.includes("time") && getPath(obj, key, null)) {
      return moment(obj[key]).format("MMMM Do YYYY, h:mm A");
    }
    if (scrollableFields.includes(key) && !isValNull(obj[key])) {
      return (obj[key] + "").split(" ").join(",");
    }
    if (key.includes("percentage") && !isValNull(obj[key])) {
      return Math.round((obj[key] + Number.EPSILON) * 100) / 100 + "%";
    }
    return !isValNull(obj[key]) ? obj[key] : "Not Available";
  };

  const handleDownloadText = (key) => {
    const csvData =
      `${key} ID's\n` + (data[key] + "").split(",").join("\n") + "\n";
    exportToCSV(csvData);
  };

  const getAuditDetailFieldValue = (obj, key) => {
    if (key.includes("updated_at") && !isValNull(obj[key])) {
      return moment(obj[key]).format("MMMM Do YYYY, h:mm A");
    }
    return !isValNull(obj[key]) ? obj[key] : "Not Available";
  };

  const sortAuditList = (audit_list) => {
    //to sort based on decreasing order of timestamp
    return audit_list.sort(function (x, y) {
      return (
        moment(y.updated_at).format("X") - moment(x.updated_at).format("X")
      );
    });
  };

  return Object.keys(data).length > 0 ? (
    <SlotDetailsListContainer>
      {SlotDetailsFields.map((field, index) => {
        return (
          <FieldDetailContainer justify="flex-start">
            <span className="field-title">{field.title}</span>
            <FlexContainer
              className="field-value"
              justify="flex-start"
              align="flex-start"
            >
              <span
                className={`${
                  scrollableFields.includes(field.key) &&
                  getPath(data, field.key, null) &&
                  "driver-ids-block"
                }`}
              >
                {getFieldValue(data, field.key)}
              </span>
              {scrollableFields.includes(field.key) &&
                getPath(data, field.key, null) && (
                  <Download
                    onClick={() => handleDownloadText(field.key)}
                    color={variables.primaryColor}
                    className="ml-10 download-icon"
                  />
                )}
            </FlexContainer>
          </FieldDetailContainer>
        );
      })}
      {data.audit_details && getPath(data.audit_details, "length", -1) > 0 && (
        <AuditDetailsHolder>
          <h3>Audit Details</h3>
          <Table
            list={sortAuditList(data.audit_details)}
            fields={AuditDetailsFields}
            getFieldValue={getAuditDetailFieldValue}
          />
        </AuditDetailsHolder>
      )}
    </SlotDetailsListContainer>
  ) : (
    <BlankState />
  );
};

const SlotDetailsListContainer = styled.div`
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: ${variables.white};
  padding: 0 24px;
  margin: 20px 0 40px;
`;

const FieldDetailContainer = styled(FlexContainer)`
    padding: 30px 0;
    font-size: 0.875rem !important;
    font-weight: 500;
    &:not(:last-child){
        border-bottom: 1px solid ${variables.grey200};
    }
    .field-title{
        flex: 0 1 30%;
        color: ${variables.grey500};
        margin-right: 10px
        font-weight: 500;
    }
    .field-value{
        flex: 0 1 70%;
        & > span{
          word-break: break-all;
          max-height: 60px;
          overflow-y: scroll;
        }
    }
    .driver-ids-block{
        border: 1px solid ${variables.grey200};
        padding:10px;
        border-radius: 8px;
    }
    .download-icon{
      cursor: pointer;
    }
`;

const AuditDetailsHolder = styled.div`
  padding: 40px 0 20px;
  h3 {
    margin-top: unset;
  }
`;

export default SlotDetailsList;
